import { countries } from "../../../common/data/countries";
import {
  COLD_STORAGE_CEILING_C,
  COLD_STORAGE_FLOOR_C,
} from "../delivery/data";


export const UserData = [
  {
    id: 1,
    year: "Dec 2021",
    achieved: 6,
    target: 7,
  },
  {
    id: 2,
    year: "Jan 2022",
    achieved: 7,
    target: 6,
  },

  {
    id: 3,
    year: "Feb 2022",
    achieved: 7.5,
    target: 8,
  },
  {
    id: 4,
    year: "Mar 2022",
    achieved: 7,
    target: 6,
  },
  {
    id: 5,
    year: "Apr 2022",
    achieved: 7,
    target: 6,
  },
  {
    id: 6,
    year: "May 2022",
    achieved: 6,
    target: 7,
  },
];

export const barUserData = [
  {
    id: 1,
    year: "Dec",
    achieved: 6,
    target: 7,
  },
  {
    id: 2,
    year: "Jan",
    achieved: 7,
    target: 6,
  },
  {
    id: 3,
    year: "Feb",
    achieved: 3,
    target: 3,
  },
  {
    id: 4,
    year: "Mar",
    achieved: 4,
    target: 5,
  },
  {
    id: 5,
    year: "Apr",
    achieved: 7,
    target: 6,
  },
  {
    id: 6,
    year: "May",
    achieved: 3,
    target: 5,
  },
  {
    id: 4,
    year: "Mar",
    achieved: 7,
    target: 4,
  },
  {
    id: 5,
    year: "Apr",
    achieved: 7,
    target: 6,
  },

  {
    id: 6,
    year: "May",
    achieved: 3,
    target: 5,
  },
  {
    id: 4,
    year: "Mar",
    achieved: 7,
    target: 4,
  },
];

export const lineOptions = {
  aspectRatio: 2.4,
  responsive: true,
  elements: {
    line: {
      borderWidth: 2,
      tension: 0.5,
      borderColor: ["#FB896B", "#6956e5"],
      borderRadius: 1,
    },
    point: {
      borderWidth: 0,
      borderColor: "transparent",
      radius: 10,
      backgroundColor: "rgba(0,0,0,.0)",
      hoverBackgroundColor: "#FB896B",
      hoverBorderWidth: 2,
      hoverBorderColor: "white",
      hoverRadius: 5,
      display: false,
    },
  },
  plugins: {
    legend: {
      align: "end",
      position: "top",
      labels: {
        boxWidth: 10,
        boxHeight: 10,
      },
      display: false,
    },
  },
  scales: {
    xAxis: {
      display: true,
      grid: {
        color: "rgba(0,0,0,0.02)",
      },
    },
    yAxis: {
      grid: {
        color: "rgba(0,0,0,.05)",
      },
      beginAtZero: true,
      max: 12,
    },
  },
};

export const barOptions = {
  aspectRatio: 1.8,
  responsive: true,
  elements: {
    bar: {
      borderWidth: 0,
      innerWidth: 2,
      barThickness: 2,
    },
  },
  plugins: {
    legend: {
      align: "center",
      position: "top",
      labels: {
        boxWidth: 10,
        boxHeight: 10,
      },
      display: false,
    },
  },
  scales: {
    xAxis: {
      display: true,
      grid: {
        color: "rgba(0,0,0,0.02)",
      },
      barThickness: 1, // number (pixels) or 'flex'
      maxBarThickness: 1,
    },
    yAxis: {
      grid: {
        color: "rgba(0,0,0,.05)",
      },
      beginAtZero: true,
    },
  },
};

// MED-723 — how the product ships.
//
// The temperature band prepopulates the delivery request; the cold chain is a
// property of the goods. The dimensions do not — each delivery asks for its own
// parcel's size — and are kept here as reference data nothing else reads.
//
// All optional; a product without them just shows empty boxes downstream.
export const productShippingFields = [
  {
    inputType: "number",
    prompt: "Package Length (cm)",
    name: "length",
    placeholder: "e.g. 22",
    fullWidth: false,
    shortWidth: true,
    tooltip:
      "Outer dimensions of the package as it ships, kept on the product for reference. Each delivery request asks for the measurements of the parcel actually going out.",
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be more than zero",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Package Width (cm)",
    name: "width",
    placeholder: "e.g. 30",
    fullWidth: false,
    shortWidth: true,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be more than zero",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Package Height (cm)",
    name: "height",
    placeholder: "e.g. 30",
    fullWidth: false,
    shortWidth: true,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be more than zero",
      },
    },
  },
  // MED-723: the temperature band applies to cold storage products only, and
  // the bounds are what make "cold storage" mean something. Without them a
  // product could be marked cold storage and given 20–30 °C, which reads as a
  // coherent range and is room temperature — and the delivery request
  // prepopulates from it and hands it to the logistics provider as the band a
  // refrigerated vehicle must hold. The same bounds are enforced on save by
  // Product::COLD_STORAGE_CEILING_C / _FLOOR_C.
  //
  // Left optional rather than required-when-cold: these columns are new, so
  // every cold storage product that already exists has them empty, and a
  // presence rule would block unrelated edits to those products until someone
  // went back and measured them.
  {
    inputType: "number",
    prompt: "Minimum Temperature (°C)",
    name: "min_temperature",
    placeholder: "e.g. 2",
    fullWidth: false,
    shortWidth: true,
    tooltip:
      "Cold storage products only. Both ends of the band are needed before the logistics provider will accept a refrigerated delivery.",
    rules: {
      minNumber: {
        expectedValue: COLD_STORAGE_FLOOR_C,
        errorMessage: `Must be at or above ${COLD_STORAGE_FLOOR_C}°C`,
      },
      maxNumber: {
        expectedValue: COLD_STORAGE_CEILING_C,
        errorMessage: `Cold storage must be at or below ${COLD_STORAGE_CEILING_C}°C`,
      },
    },
  },
  {
    inputType: "number",
    prompt: "Maximum Temperature (°C)",
    name: "max_temperature",
    placeholder: "e.g. 8",
    fullWidth: false,
    shortWidth: true,
    tooltip:
      "Cold storage products only. Must be at or above the minimum temperature.",
    rules: {
      minNumber: {
        expectedValue: COLD_STORAGE_FLOOR_C,
        errorMessage: `Must be at or above ${COLD_STORAGE_FLOOR_C}°C`,
      },
      maxNumber: {
        expectedValue: COLD_STORAGE_CEILING_C,
        errorMessage: `Cold storage must be at or below ${COLD_STORAGE_CEILING_C}°C`,
      },
    },
  },
];

export const importerProductForm = [
  {
    inputType: "selectInput",
    prompt: "ATC code",
    options_name: "atc_code",
    name: "atc_code_id",
    placeholder: "Enter upto 3 characters to search",
    fullWidth: false,
    shortWidth: true,
    options: [],
    valueType: "ATC",
    required: true,
  },
  {
    inputType: "text",
    prompt: "Product Brand",
    options_name: "product_brand",
    name: "brand_name",
    placeholder: "Type your product brand",
    fullWidth: false,
    shortWidth: true,
    required: true,
    rules: {
      minLength: {
        errorMessage: "should be at least 2 characters",
        expectedValue: 2,
      },
    },
  },
  {
    inputType: "text",
    prompt: "Product Manufacturer",
    name: "manufacturer_name",
    placeholder: "Type your product manufacturer",
    fullWidth: false,
    shortWidth: true,
    required: true,
    rules: {
      minLength: {
        errorMessage: "should be at least 2 characters",
        expectedValue: 2,
      },
    },
  },
  {
    inputType: "selectInput",
    prompt: "Where is your product shipping from",
    options_name: "shipping_continent",
    name: "country_of_origin",
    placeholder: "Choose a country",
    fullWidth: false,
    shortWidth: true,
    options: countries,
    required: true,
  },

  {
    inputType: "selectInput",
    prompt: "Product Classification",
    name: "classification",
    options_name: "classifications",
    placeholder: "Select your product classification",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Pharmaceuticals" }],
    required: true,
  },

  //comback here
  {
    inputType: "selectInput",
    prompt: "Product Storage Requirement",
    name: "storage_requirement",
    options_name: "storage_requirements",
    placeholder: "Select your product storage requirement",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Pharmaceuticals" }],
    required: true,
  },
  {
    inputType: "selectInput",
    prompt: "Product form",
    options_name: "forms",
    name: "form",
    placeholder: "Select your product form",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Liquid" }],
    required: true,
  },

  {
    inputType: "selectInput",
    prompt: "Product regulation",
    name: "regulation",
    options_name: "regulations",
    placeholder: "Select your product regulation",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Prescription" }],
    required: true,
  },

  {
    inputType: "text",
    prompt: "NAFDAC number",
    name: "nafdac_number",
    placeholder: "Type your NAFDAC number",
    fullWidth: false,
    shortWidth: true,
    maxLength: 7,
    rules: {
      length: {
        errorMessage: "Should be 7 digits",
        expectedValue: 7,
      },
      onlyDigit: {
        expectedValue: true,
        errorMessage: "NAFDAC number can only be digits",
      },
    },
    required: true,
  },

  {
    inputType: "selectInput",
    prompt: "Product Weight unit",
    name: "strength_unit",
    options_name: "strength_units",
    placeholder: "Select your product strength units",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Miligrams" }],
    required: true,
  },
  {
    inputType: "number",
    prompt: "Product Weight",
    name: "strength",
    placeholder: "Enter the product weight",
    fullWidth: false,
    shortWidth: true,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be more than zero",
      },
    },
    required: true,
  },
  // MED-723: see productShippingFields.
  ...productShippingFields,
];

export const manufacturerProductForm = [
  {
    inputType: "selectInput",
    prompt: "ATC code",
    options_name: "atc_code",
    name: "atc_code_id",
    placeholder: "Enter upto 3 characters to search",
    fullWidth: false,
    shortWidth: true,
    options: [],
    valueType: "ATC",
    required: true,
  },
  {
    inputType: "text",
    prompt: "Product Brand",
    name: "brand_name",
    options_name: "product_brand",
    placeholder: "Select ATC code first",
    readOnly: true,
    fullWidth: false,
    shortWidth: true,
    required: true,
  },

  {
    inputType: "selectInput",
    prompt: "Product Classification",
    name: "classification",
    options_name: "classifications",
    placeholder: "Select your product classification",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Pharmaceuticals" }],
    required: true,
  },

  //comback here
  {
    inputType: "selectInput",
    prompt: "Product Storage Requirement",
    name: "storage_requirement",
    options_name: "storage_requirements",
    placeholder: "Select your product storage requirement",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Pharmaceuticals" }],
    required: true,
  },
  {
    inputType: "selectInput",
    prompt: "Product form",
    options_name: "forms",
    name: "form",
    placeholder: "Select your product form",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Liquid" }],
    required: true,
  },

  {
    inputType: "selectInput",
    prompt: "Product regulation",
    name: "regulation",
    options_name: "regulations",
    placeholder: "Select your product regulation",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Prescription" }],
    required: true,
  },

  {
    inputType: "text",
    prompt: "NAFDAC number",
    name: "nafdac_number",
    placeholder: "Type your NAFDAC number",
    fullWidth: false,
    shortWidth: true,
    maxLength: 7,
    rules: {
      length: {
        errorMessage: "Should be 7 digits",
        expectedValue: 7,
      },
      onlyDigit: {
        expectedValue: true,
        errorMessage: "NAFDAC number can only be digits",
      },
    },

    required: true,
  },

  {
    inputType: "selectInput",
    prompt: "Product Strength unit",
    name: "strength_unit",
    options_name: "strength_units",
    placeholder: "Select your product strength units",
    fullWidth: false,
    shortWidth: true,
    options: [{ id: 1, title: "Miligrams" }],
    required: true,
  },
  {
    inputType: "number",
    prompt: "Product Strength",
    name: "strength",
    placeholder: "Enter the product weight",
    fullWidth: false,
    shortWidth: true,
    tooltip: "This refers to the strenth in terms of 500Mg",
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be more than zero",
      },
    },
    required: true,
  },
  // MED-723: see productShippingFields.
  ...productShippingFields,
];
